export default __webpack_public_path__ + "static/falcibaci-365a343e9e06600e3b2f77deaf447b4e.png";